import Api from '@/api/api'

export default {
    login(data) {
        return Api.post('/Org/auth/authenticate', data)
    }
}